import { observer } from "mobx-react-lite";
import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { langStore } from "@noli/business";
import styles from "./index.module.scss";
import { loginStore } from "@/modules/login/store";
import Input from "@/pages/Setting/components/Input";
import {
  bindPhone,
  bindWechat,
  getWeChatQrCode,
  getWeChatQrCodeScanStatus,
  pwdSet,
  unbindWechat,
} from "@/pages/Setting/api";
import { Toast } from "@/components/Toast";
import { useAsyncEffect, useClickAway } from "ahooks";
import config from "@/config";
let timer: any;
const BindWechat: FC<any> = (props) => {
  const { onClose, type } = props;
  const lang = langStore.tgt;
  const {
    userState: { userInfo },
  } = loginStore;
  const weChatContentRef = useRef<HTMLDivElement | null>(null);
  const [qrcodeUrl, setQrcodeUrl] = useState("");
  useClickAway(() => {
    onClose && onClose();
  }, [weChatContentRef]);
  useAsyncEffect(async () => {
    if (type === 2) {
      try {
        const {
          data: { url, key },
        } = await getWeChatQrCode();
        setQrcodeUrl(url);
        //如果timer存在，清除timer
        if (timer) {
          clearInterval(timer);
        }
        timer = setInterval(async () => {
          const {
            data: { scanned },
          } = await getWeChatQrCodeScanStatus({ key });
          if (scanned) {
            clearInterval(timer);
            await bindWechat({ key });
            Toast({
              status: "success",
              title: "微信绑定成功",
            });
            await loginStore.getUserInfo();
            onClose && onClose();
          }
        }, 1000);
      } catch (e) {
        console.error(e);
      }
    }
  }, []);
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose && onClose();
      }
    };
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);
  const confirmUnbinding = async () => {
    try {
      await unbindWechat();
      await loginStore.getUserInfo();
      onClose && onClose();
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <div className={styles.dialogWrapper} style={{ borderStyle: "none", flexFlow: "column" }}>
      {type === 1 ? (
        <div className={styles.weChatContent} ref={weChatContentRef}>
          <img
            src={`${config.buildCdnBaseUrl}assets/creator/white-close.png`}
            alt=""
            className={styles.close}
            onClick={onClose}
          />
          <p className={styles.whiteContent}>解绑后无法使用该微信号登陆此账号， 您确定要解绑吗？</p>
          <div className={styles.btnWrapper}>
            <button
              className={styles.submit}
              onClick={async () => {
                onClose && onClose();
              }}
            >
              暂不解绑
            </button>
            <button className={styles.default} onClick={confirmUnbinding}>
              确定解绑
            </button>
          </div>
        </div>
      ) : (
        <div className={styles.dialogContent} ref={weChatContentRef}>
          <img
            src={`${config.buildCdnBaseUrl}assets/creator/bytesize_close.png`}
            alt=""
            className={styles.close}
            onClick={onClose}
          />
          <p className={styles.title}>绑定微信</p>
          <div className={styles.qrcodeWrapper}>
            {qrcodeUrl ? (
              <img src={qrcodeUrl} alt="" className={styles.qrcode} />
            ) : (
              <div className={styles.loadingWrapper}>
                <img src={`${config.buildCdnBaseUrl}assets/creator/loading-list.gif`} alt="" />
              </div>
            )}
          </div>
          <p className={styles.tip} style={{ marginBottom: 30 }}>
            请扫描上方的二维码进行微信绑定
          </p>
        </div>
      )}
    </div>
  );
};
export default observer(BindWechat);
